<template>
    <div>
    <el-dialog title="权限范围" :visible.sync="dialogVisible" @close='dialogFormVisible' 
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form" :rules="formRules">            
            <el-form-item label="权限范围" :label-width="formLabelWidth">
                <el-tree v-if="category" ref="tree" :data="category" 
                show-checkbox node-key="role_key" 
                accordion 
                :default-expand-all="expand_all" 
                :auto-expand-parent="expand_all" 
                :default-checked-keys="category_ids" 
                :default-expanded-keys="category_ids" 
                :props="defaultProps" 
                @check="handleCheckChange">
                    <div class="tree-node" slot-scope="{data}">
                        <div>
                        <!-- <el-tag type="info" class="style1-tag" v-if="data.level==1">{{ type[data.type].name }}</el-tag> -->
                        <span :class="data.status == 0 ? 'text-d-line' : ''">{{ data.name }} <span v-if="data.category_id">({{ data.category_id }})</span> </span>
                        <span class="red ml10" v-if="data.is_lock == 1">收费</span>
                        <span class="gray9 ml10" v-if="days[data.role_key]">剩余：{{days[data.role_key]}}</span>
                        </div>
                    </div>
                </el-tree>
            </el-form-item>
        </el-form>
        <div slot="title" class="dialog-footer">
            <div class="d-s-s">
                <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
                <div class="d-s-s d-c">
                    
                    <div class="p-0-10" v-if="type">
                        <span>权限模版：</span>
                        <el-select v-model="role_index" size="mini" @change="changeRole" style="width:200px">
                            <el-option value="-1" label="默认"></el-option>
                            <el-option :value="index" :label="item.name" :key="index" v-for="(item, index) in role">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #999999;">{{ type[item.type].name }}</span>
                            </el-option>
                        </el-select>
                        <el-button size="mini" @click="onClear">清空</el-button>
                        <el-button size="mini" @click="onExpandAll">{{ expand_all ? '收缩' : '展开'}}</el-button>
                    </div>
                    <p class="p10">
                        <span>用户：{{ form.nickName }}</span>
                        <span class="blue ml10"><i class="el-icon-warning"></i> 如果以前存在不勾选会删除原来的</span>
                    </p>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
    </div>
</template>

<script>
import UserRoleApi from '@/api/study/user_role.js';
import UserApi from '@/api/user.js';
export default {
    data() {
        return {
            /*左边长度*/
            formLabelWidth: '120px',
            /*是否显示*/
            dialogVisible: false,
            loading: false,
            formRules: {
                // name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                // type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
            },
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            expand_all: false,
            category: [],
            category_ids: [],
            old_category_ids: [],
            save_category_ids: [],
            type: [],
            role: [],
            role_index: '-1',
            days: {},
        };
    },
    props: ['open_role', 'form'],
    created() {
        this.dialogVisible = this.open_role;
        // this.category_ids = this.form.category_ids;
        // this.old_category_ids = this.form.category_ids;
        this.getRoleIds();
        this.typeChange();
        this.roleChange();
    },
    methods: {
        // 取id
        pushId(data){
            let id = data.role_key;
            let index = this.category_ids.indexOf(id);
            if(index == -1 && (data.level == 3 || (data.type == 60 && data.level == 2) || (data.type == 83 && data.level == 1) || data.key_name == 81 || data.key_name == 82)){
                this.category_ids.push(id);
            }
            // console.log(this.category_ids);
        },
        // 找子级
        findChildren(data){
            if (data.children && data.children.length > 0 ){
                for (var i = 0; i < data.children.length; i++) {
                    this.findChildren(data.children[i]);
                }
            }else{
                this.pushId(data);
            }
        },
        //监听选中
        handleCheckChange(data, checked) {
            // console.log(checked.checkedKeys, checked.halfCheckedKeys);
            this.category_ids = checked.checkedKeys;
            console.log('save', this.category_ids);

            // 保存全部
            // let checkedKeys = this.$refs.tree.getCheckedKeys();
            // let parentKeys = this.$refs.tree.getHalfCheckedKeys();
            // let roles = checkedKeys.concat(parentKeys).toString(','); // 保存的roles
            // console.log(roles);

            // this.save_category_ids = checked.checkedKeys.concat(checked.halfCheckedKeys);
            // if (data.key_name == 60 || data.key_name == 70 || data.key_name == 71 || data.key_name == 83){
            //     for (const id of checked.checkedKeys) {
            //         if(this.category_ids.indexOf(id) === -1){
            //             this.category_ids.push(id);
            //         }
            //     }
            // }
            // if (data.key_name != 60 || data.key_name != 70 || data.key_name != 71 || data.key_name != 83){
            //     checked.checkedNodes.forEach(v => {
            //         this.findChildren(v);
            //     });
            // }
            // console.log('save', this.save_category_ids);
        },
        // 收缩或展开
        onExpandAll(){
            this.expand_all = !this.expand_all;
            this.$nextTick(() => {
                for(var i=0;i<this.$refs.tree.store._getAllNodes().length;i++){
                    this.$refs.tree.store._getAllNodes()[i].expanded=this.expand_all;
                }
            });
        },
        /*清空*/
        onClear(){
            this.$refs.tree.setCheckedKeys([]);
            this.role_index = '-1';
            this.category_ids = [];
        },
        /*权限切换*/
        changeRole(){
            this.$refs.tree.setCheckedKeys([]);
            if (this.role_index < 0){
                this.category_ids = this.old_category_ids
                return;
            } 
            this.category_ids = this.role[this.role_index].category_ids;
        },
        /*选择类型*/
        getRoleIds(){
            let self = this;
            UserApi.roleIds({user_id: self.form.user_id}, true).then(res => {
                if (res.code == 1) {
                    self.category_ids = res.data.ids;
                    self.days = res.data.days;
                    self.old_category_ids = res.data;
                }
            });
        },
        /*选择类型*/
        roleChange(){
            let self = this;
            UserRoleApi.getList({is_page:0}, true).then(res => {
                if (res.code == 1) {
                    self.role = res.data.list;
                    self.type = res.data.type;
                }
            });
        },
        /*选择类型*/
        typeChange(){
            let self = this;
            UserRoleApi.category({is_tree: 1}, true).then(res => {
                if (res.code == 1) {
                    self.category = res.data;
                }
            });
        },
        /*修改分类*/
        editCategory() {
            let self = this;
            let params = [];
            params.user_id = self.form.user_id;
            params.category_ids = self.category_ids.toString();
            self.$refs.form.validate((valid) => {
                if (valid) {
                self.$confirm('是否提交修改？').then(_ => {
                self.loading = true;
                UserApi.studyUpdateCodeUser(params, true)
                    .then(data =>
                    {
                        self.loading = false;
                        self.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        self.dialogFormVisible(true);

                    })
                    .catch(error =>
                    {
                        self.loading = false;
                    });
                })
                }
                
            });
        },

        /*关闭弹窗*/
        dialogFormVisible(e) {
            if (e) {
                this.$emit('closeDialog', {
                    type: 'success',
                    openDialog: false
                })
            } else {
                this.$emit('closeDialog', {
                    type: 'error',
                    openDialog: false
                })
            }
        },

    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Role.vue